import React from 'react';
import styles from './ActiveChatTopBar.module.css';
import { FaMask } from 'react-icons/fa';
import { shareIcon } from '../../assets/icons';

interface SettingsMenuProps {
  onSetPersona: () => void;
  onShareCharacter: () => void;
  showSetPersona?: boolean;
}

function ActiveChatSettingsMenu({ onSetPersona, onShareCharacter, showSetPersona = true }: SettingsMenuProps) {
  // Prevent event propagation for the entire menu
  const handleMenuClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div className={styles.backgroundMenu} onClick={handleMenuClick}>
      {showSetPersona && (
        <>
          <button 
            className={styles.menuItem}
            onClick={onSetPersona}
          >
            <FaMask />
            Set Persona
          </button>
          <div className={styles.menuDivider}></div>
        </>
      )}
      <button 
        className={styles.menuItem}
        onClick={onShareCharacter}
      >
        <img src={shareIcon} alt="Share" className={styles.menuItemIcon} />
        Share Character
      </button>
    </div>
  );
}

export default ActiveChatSettingsMenu; 